import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withContent from './withContent';
import { default as pageContent, contentPropTypes } from './backEndErrors.content';

export default (WrappedComponent) => {
	const withBackEndError = class extends Component {
		constructor(props) {
			super(props);
			this.onBlur = this.onBlur.bind(this);
		}
		onBlur(event) {
			const { updateValidation, validations, id, onBlur } = this.props;
			const { isBackEndError = false } = get(validations, id, {});
			if (isBackEndError) {
				return updateValidation(id, false, false, true);
			}
			return onBlur(event);
		}
		render() {
			const { validations, id, errorMessage, isValid, showValidation, content } = this.props;
			const { isBackEndError = false, errorCode } = get(validations, id, {});
			const backEndErrorMessage = isBackEndError ? content[errorCode] || '' : errorMessage;
			return (
				<WrappedComponent
					{...{
						...this.props,
						errorMessage: backEndErrorMessage,
						isValid: isBackEndError ? false : isValid,
						showValidation: isBackEndError || showValidation,
						onBlur: this.onBlur,
					}}
				/>
			);
		}
	};
	withBackEndError.displayName = `withBackEndError(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;

	withBackEndError.propTypes = {
		id: PropTypes.string.isRequired,
		errorMessage: PropTypes.string,
		isValid: PropTypes.bool.isRequired,
		showValidation: PropTypes.bool.isRequired,
		validations: PropTypes.shape({}).isRequired,
		updateValidation: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
		content: PropTypes.shape(contentPropTypes).isRequired,
	};

	return withContent({ content: pageContent })(withBackEndError);
};
